import { ERROR, READY, RELOADING, UNINITIALIZED, useVisualState } from '../../../../hooks/useVisualState'
import React, { useCallback, useEffect } from 'react'
import { Route, Switch, withRouter } from 'react-router-dom'

import Button from '../../../../components/Button/Button'
import CategoryCard from '../../../../components/Cards/CategoryCard/CategoryCard'
import GenericErrorModal from '../../../../modules/GenericErrorModal/GenericErrorModal'
import OldCategoryFormModal from './OldCategoryFormModal'
import OldDynamicFieldsFormModal from './OldDynamicFieldsFormModal'
import { oldGet } from '../../../../helpers/requestOld'
import t from '../../../../helpers/i18n'
import useForceUpdate from '../../../../hooks/useForceUpdate'
import { useSelector } from 'react-redux'

const OldCategoriesView = withRouter(({ history }) => {
  const profile = useSelector(state => state.profile)
  const [[categoriesState, categories], setCategories] = useVisualState()
  const [update, forceUpdate] = useForceUpdate()

  const handleClose = useCallback(() => {
    history.push("/cm/categories")
    forceUpdate()
  }, [history, forceUpdate])

  const handleOpenProfile = useCallback((category_id) => history.push("/cm/categories/" + category_id), [history])
  const handleEditDynamicFields = useCallback(category_id => history.push("/cm/categories/" + category_id + "/dynamic_fields"), [history])

  useEffect(() => {
    setCategories(RELOADING)
    oldGet('/cm/categories')
      .then(response => setCategories(READY, response))
      .catch(error => setCategories(ERROR, error))
  }, [update, setCategories])

  return (
    <div className="main-content">
      <div className="-page-header">
        <div className="-left label-extra-large-semibold">{t('Categories')}</div>
        <div className="-center"></div>
        <div className="-right">
          {profile.products.BETA &&
            <Button
              label={t("Add Category")}
              icon="AddIcon"
              type="dark"
              color="green"
              onClick={() => handleOpenProfile('new')}
            />
          }
        </div>
      </div>

      <div className="-content">
        {categoriesState !== ERROR && categories && categories.map(category => (
          <CategoryCard
            key={category.category_id}
            category_id={category.category_id}
            name={category.name}
            tags={[category.short_name]}
            logo={category.logo}
            city={category.city}
            emails_count={category.emails_count}
            teams_count={category.teams_count}
            players_limit={category.players_limit}
            onClick={() => handleOpenProfile(category.category_id)}
            onEditDynamicFields={handleEditDynamicFields}
          />
        ))}
      </div>

      <Switch>
        <Route exact path="/cm/categories/:categoryId">
          <OldCategoryFormModal onCloseRequested={handleClose} />
        </Route>
        <Route exact path="/cm/categories/:categoryId/dynamic_fields">
          <OldDynamicFieldsFormModal onCloseRequested={handleClose} />
        </Route>
      </Switch>

      {categoriesState === ERROR && <GenericErrorModal error={categories} i18nPrefix="OldTeamsView" onCloseRequested={() => setCategories(UNINITIALIZED)} />}
    </div>
  )
})

export default OldCategoriesView